<h2 mat-dialog-title>Identificação</h2>
<mat-dialog-content
  style="
    overflow-y: scroll;
    overflow-x: hidden;
    height: 20em;
    white-space: nowrap;
  "
>
  <div fxLayout="row wrap" style="margin-top: 10px">
    <div fxFlex="100" fxFlex.gt-md="calc(100% - 300px) " fxFlex.gt-sm="50">
      <mat-form-field
        style="width: 100%"
        appearance="fill"
        [formGroup]="methodToSendForm"
      >
        <mat-label>{{ titleToMethodSend }}:</mat-label>
        <mat-select
          formControlName="methodToSend"
          (selectionChange)="methodSelected()"
        >
          <mat-option *ngFor="let method of methodToSendCode" [value]="method">
            {{ method.method }} : {{ method.destinationView }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <br />

      <button
        *ngIf="!hideSendKeyButton"
        mat-raised-button
        style="height: 50px"
        class="mat-primary full-width mb-1 no-shadow"
        [disabled]="!validSelected"
        (click)="sendKey(rForm.value)"
      >
        {{ globalMessage.submitSendCode }}
      </button>
    </div>
  </div>

  <form [formGroup]="rForm" (ngSubmit)="signin(rForm.value)">
    <div class="pb-1">
      <input
        type="text"
        maxlength="{{ maxLengthToMethodSend }}"
        style="
          background-color: rgb(255, 255, 255);
          color: #4396a2;
          font-weight: bold;
        "
        name="code2Factor"
        autocomplete="off"
        autofocus
        formControlName="code2Factor"
        placeholder="{{ placeholderSendKey }}"
        ngInput
        (input)="catchEntry(rForm.controls['code2Factor'].value)"
      />
      <br />

      <!-- <mat-error
        class="error"
        *ngIf="
          rForm.controls['code2Factor'].hasError('required') &&
          rForm.controls['code2Factor'].touched
        "
      >
        <small>{{ globalMessage.error }}</small>
      </mat-error> -->

      <mat-error class="error" *ngIf="!validCode">
        <small>{{ messageErrorInvalid }}</small>
      </mat-error>

      <br />

      <button
        mat-raised-button
        style="height: 50px"
        class="mat-primary full-width mb-1 no-shadow"
        [disabled]="!validCode"
      >
        {{ globalMessage.submitButton }}
      </button>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <span fxFlex></span>
  <button
    type="button"
    mat-raised-button
    color="primary2"
    style="box-shadow: none !important"
    (click)="dialogRef.close(true)"
  >
    Voltar
  </button>
</mat-dialog-actions>
<!--
<mat-dialog-actions>
  <p *ngIf="debtor !== undefined" style="margin-top: 1em">
    <small>Cliente: {{ debtor?.name }} <br />CPF/CNPJ: {{ debtor?.cpfCnpj }}
    </small>
  </p>
  <span fxFlex></span>
  <button type="button" mat-raised-button color="primary2" style="box-shadow: none !important;"
    (click)="dialogRef.close(true)">
    Voltar
  </button>
</mat-dialog-actions> -->
